import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import stl from "./LimitedAvaInfoBox.module.css";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import loadable from "@loadable/component";
var fallback = {
  fallback: "Loading..."
};
var BottomSheetPopup = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "componentsShared-BottomSheetPopup__OLD-BottomSheetPopup";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "componentsShared-BottomSheetPopup__OLD-BottomSheetPopup" */"@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup");
    }
    return eval('require.resolve')("@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup");
  }
}, fallback);
var LimitedAvaInfoBox = function LimitedAvaInfoBox() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    showPopUp = _useState[0],
    setShowPopUp = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.infoFlex + " mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.infoContainer)
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/limited_warning_icon.svg",
    alt: "w"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.text
  }, /*#__PURE__*/React.createElement("p", null, t("car_currently_unavailable", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.flex
  }, /*#__PURE__*/React.createElement("p", {
    className: "en:text-left"
  }, t("book_provide_within_two_weeks", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("p", {
    className: "en:text-right line-clamp-1",
    onClick: function onClick() {
      return setShowPopUp(true);
    }
  }, t("learn", {
    ns: "web_post_view"
  })))))), showPopUp && /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: showPopUp,
    onClose: function onClose() {
      return setShowPopUp(false);
    },
    className: stl.customPopUp
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.popupContainer
  }, /*#__PURE__*/React.createElement("h3", null, " ", t("notice_regarding_car_availability", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, t("car_currently_unavailable_team_work", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("li", null, " ", t("unavailable_contacted", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("li", null, " ", t("error_get_refund_deposit_unable_provide", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("li", null, " ", t("car_price_final_change_depending", {
    ns: "web_post_view"
  }))))));
};
export default LimitedAvaInfoBox;